var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("v-tour", {
        attrs: {
          name: "task-list",
          steps: _vm.tourSteps,
          callbacks: _vm.tourCallbacks,
          options: _vm.$utils.tour.getOptions(true)
        }
      }),
      _c(
        "el-card",
        { staticStyle: { "border-radius": "0" } },
        [
          _c("div", { staticClass: "filter" }, [
            _c(
              "div",
              { staticClass: "left" },
              [
                _c(
                  "el-form",
                  {
                    staticClass: "filter-form",
                    attrs: {
                      model: _vm.filter,
                      "label-width": "100px",
                      "label-position": "right",
                      inline: ""
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Type") } },
                      [
                        _c(
                          "el-button-group",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "small",
                                  type:
                                    _vm.filter.type === "spider"
                                      ? "primary"
                                      : ""
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.onClickType("spider")
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("Spider Tasks")) + " "
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "small",
                                  type:
                                    _vm.filter.type === "system"
                                      ? "primary"
                                      : ""
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.onClickType("system")
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("System Tasks")) + " "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "node_id", label: _vm.$t("Node") } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              size: "small",
                              placeholder: _vm.$t("Node")
                            },
                            on: { change: _vm.onFilterChange },
                            model: {
                              value: _vm.filter.node_id,
                              callback: function($$v) {
                                _vm.$set(_vm.filter, "node_id", $$v)
                              },
                              expression: "filter.node_id"
                            }
                          },
                          [
                            _c("el-option", {
                              attrs: { value: "", label: _vm.$t("All") }
                            }),
                            _vm._l(_vm.nodeList, function(node) {
                              return _c("el-option", {
                                key: node._id,
                                attrs: { value: node._id, label: node.name }
                              })
                            })
                          ],
                          2
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "spider_id", label: _vm.$t("Spider") } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              size: "small",
                              placeholder: _vm.$t("Spider"),
                              disabled: _vm.isFilterSpiderDisabled
                            },
                            on: { change: _vm.onFilterChange },
                            model: {
                              value: _vm.filter.spider_id,
                              callback: function($$v) {
                                _vm.$set(_vm.filter, "spider_id", $$v)
                              },
                              expression: "filter.spider_id"
                            }
                          },
                          [
                            _c("el-option", {
                              attrs: { value: "", label: _vm.$t("All") }
                            }),
                            _vm._l(_vm.allSpiderList, function(spider) {
                              return _c("el-option", {
                                key: spider._id,
                                attrs: { value: spider._id, label: spider.name }
                              })
                            })
                          ],
                          2
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { prop: "status", label: _vm.$t("Status") } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              size: "small",
                              placeholder: _vm.$t("Status")
                            },
                            on: { change: _vm.onFilterChange },
                            model: {
                              value: _vm.filter.status,
                              callback: function($$v) {
                                _vm.$set(_vm.filter, "status", $$v)
                              },
                              expression: "filter.status"
                            }
                          },
                          [
                            _c("el-option", {
                              attrs: { value: "", label: _vm.$t("All") }
                            }),
                            _c("el-option", {
                              attrs: {
                                value: "pending",
                                label: _vm.$t("Pending")
                              }
                            }),
                            _c("el-option", {
                              attrs: {
                                value: "running",
                                label: _vm.$t("Running")
                              }
                            }),
                            _c("el-option", {
                              attrs: {
                                value: "finished",
                                label: _vm.$t("Finished")
                              }
                            }),
                            _c("el-option", {
                              attrs: { value: "error", label: _vm.$t("Error") }
                            }),
                            _c("el-option", {
                              attrs: {
                                value: "cancelled",
                                label: _vm.$t("Cancelled")
                              }
                            }),
                            _c("el-option", {
                              attrs: {
                                value: "abnormal",
                                label: _vm.$t("Abnormal")
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "right" },
              [
                _vm.selectedRunningTasks.length > 0
                  ? _c(
                      "el-button",
                      {
                        staticClass: "btn-stop",
                        attrs: {
                          icon: "el-icon-video-pause",
                          size: "small",
                          type: "info"
                        },
                        on: { click: _vm.onStopMultipleTask }
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("Cancel")) + " ")]
                    )
                  : _vm._e(),
                _vm.selectedTasks.length > 0
                  ? _c(
                      "el-button",
                      {
                        staticClass: "btn-restart",
                        attrs: {
                          icon: "el-icon-refresh",
                          size: "small",
                          type: "warning"
                        },
                        on: { click: _vm.onRestartMultipleTask }
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("Restart")) + " ")]
                    )
                  : _vm._e(),
                _vm.selectedTasks.length > 0
                  ? _c(
                      "el-button",
                      {
                        staticClass: "btn-delete",
                        attrs: {
                          icon: "el-icon-delete",
                          size: "small",
                          type: "danger"
                        },
                        on: { click: _vm.onRemoveMultipleTask }
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("Remove")) + " ")]
                    )
                  : _vm._e()
              ],
              1
            )
          ]),
          _c("status-legend"),
          _c(
            "el-table",
            {
              ref: "table",
              staticClass: "table",
              attrs: {
                data: _vm.filteredTableData,
                "header-cell-style": {
                  background: "rgb(48, 65, 86)",
                  color: "white"
                },
                border: "",
                "row-key": "_id"
              },
              on: {
                "row-click": _vm.onRowClick,
                "selection-change": _vm.onSelectionChange
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "selection",
                  width: "45",
                  align: "center",
                  "reserve-selection": ""
                }
              }),
              _vm._l(_vm.columns, function(col) {
                return [
                  col.name === "spider_name"
                    ? _c("el-table-column", {
                        key: col.name,
                        attrs: {
                          label: _vm.$t(col.label),
                          sortable: col.sortable,
                          align: col.align
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "a-tag",
                                      attrs: { href: "javascript:" },
                                      on: {
                                        click: function($event) {
                                          return _vm.onClickSpider(scope.row)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(scope.row[col.name]))]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    : col.name.match(/_ts$/)
                    ? _c("el-table-column", {
                        key: col.name,
                        attrs: {
                          label: _vm.$t(col.label),
                          sortable: col.sortable,
                          align: col.align,
                          width: col.width
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.getTime(scope.row[col.name])) +
                                      " "
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    : col.name === "wait_duration"
                    ? _c("el-table-column", {
                        key: col.name,
                        attrs: {
                          label: _vm.$t(col.label),
                          sortable: col.sortable,
                          align: col.align,
                          width: col.width
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.getWaitDuration(scope.row)) +
                                      " "
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    : col.name === "runtime_duration"
                    ? _c("el-table-column", {
                        key: col.name,
                        attrs: {
                          label: _vm.$t(col.label),
                          sortable: col.sortable,
                          align: col.align,
                          width: col.width
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getRuntimeDuration(scope.row)
                                      ) +
                                      " "
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    : col.name === "total_duration"
                    ? _c("el-table-column", {
                        key: col.name,
                        attrs: {
                          label: _vm.$t(col.label),
                          sortable: col.sortable,
                          align: col.align,
                          width: col.width
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.getTotalDuration(scope.row)) +
                                      " "
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    : col.name === "node_name"
                    ? _c("el-table-column", {
                        key: col.name,
                        attrs: {
                          label: _vm.$t(col.label),
                          sortable: col.sortable,
                          align: col.align,
                          width: col.width
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "a-tag",
                                      attrs: { href: "javascript:" },
                                      on: {
                                        click: function($event) {
                                          return _vm.onClickNode(scope.row)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(scope.row[col.name]))]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    : col.name === "status"
                    ? _c("el-table-column", {
                        key: col.name,
                        attrs: {
                          label: _vm.$t(col.label),
                          sortable: col.sortable,
                          align: col.align,
                          width: col.width
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("status-tag", {
                                    attrs: { status: scope.row[col.name] }
                                  }),
                                  scope.row.error_log_count > 0
                                    ? [
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              content:
                                                _vm.$t("Log Errors") +
                                                ": " +
                                                scope.row.error_log_count,
                                              placement: "top"
                                            }
                                          },
                                          [
                                            _c(
                                              "el-tag",
                                              {
                                                staticStyle: {
                                                  "margin-left": "10px"
                                                },
                                                attrs: { type: "danger" }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "el-icon-warning"
                                                }),
                                                _c("i", {
                                                  staticClass: "el-icon-tickets"
                                                })
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    : _vm._e()
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    : _c("el-table-column", {
                        key: col.name,
                        attrs: {
                          property: col.name,
                          label: _vm.$t(col.label),
                          sortable: col.sortable,
                          align: col.align,
                          width: col.width
                        }
                      })
                ]
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("Action"),
                  align: "left",
                  fixed: "right",
                  width: "200px"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            attrs: { content: _vm.$t("View"), placement: "top" }
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                type: "primary",
                                icon: "el-icon-search",
                                size: "mini"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onView(scope.row)
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t("Restart"),
                              placement: "top"
                            }
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                type: "warning",
                                icon: "el-icon-refresh",
                                size: "mini"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onRestart(scope.row, $event)
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t("Remove"),
                              placement: "top"
                            }
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                type: "danger",
                                icon: "el-icon-delete",
                                size: "mini"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onRemove(scope.row, $event)
                                }
                              }
                            })
                          ],
                          1
                        ),
                        ["pending", "running"].includes(scope.row.status)
                          ? _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: _vm.$t("Stop"),
                                  placement: "top"
                                }
                              },
                              [
                                _c("el-button", {
                                  attrs: {
                                    type: "info",
                                    icon: "el-icon-video-pause",
                                    size: "mini"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.onStop(scope.row, $event)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ])
              })
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.pageNum,
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.pageSize,
                  layout: "sizes, prev, pager, next",
                  total: _vm.taskListTotalCount
                },
                on: {
                  "update:currentPage": function($event) {
                    _vm.pageNum = $event
                  },
                  "update:current-page": function($event) {
                    _vm.pageNum = $event
                  },
                  "update:pageSize": function($event) {
                    _vm.pageSize = $event
                  },
                  "update:page-size": function($event) {
                    _vm.pageSize = $event
                  },
                  "current-change": _vm.onPageChange,
                  "size-change": _vm.onPageChange
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }